import React from 'react';

import { Form } from '@react/react-spectrum/Form';
import FieldLabel from '@react/react-spectrum/FieldLabel';
import Heading from '@react/react-spectrum/Heading';
import Textfield from '@react/react-spectrum/Textfield';

export default function SalesforceDetailsForm({ formData, setFormData }) {
  const handleChange = (fieldName) => (value) => {
    setFormData(fieldName, value);
  };

  return (
    <Form>
      <Heading size={3}>Salesforce environment details</Heading>

      <FieldLabel label="Name">
        <Textfield
          placeholder="My Salesforce Instance"
          name="name"
          defaultValue={formData.name}
          onChange={handleChange('name')}
        />
      </FieldLabel>

      <FieldLabel label="Instance URL">
        <Textfield
          placeholder=""
          name="instanceUrl"
          defaultValue={formData.details?.instanceUrl}
          onChange={handleChange('details.instanceUrl')}
        />
      </FieldLabel>

      <FieldLabel label="Security token">
        <Textfield
          placeholder=""
          name="securityToken"
          defaultValue={formData.credentials?.securityToken}
          onChange={handleChange('credentials.securityToken')}
        />
      </FieldLabel>

      <div className="username-password">
        <FieldLabel label="User name">
          <Textfield
            name="userName"
            defaultValue={formData.credentials?.userName}
            onChange={handleChange('credentials.userName')}
          />
        </FieldLabel>
        <FieldLabel label="Password">
          <Textfield
            type="password"
            name="password"
            defaultValue={formData.credentials?.password}
            onChange={handleChange('credentials.password')}
          />
        </FieldLabel>
      </div>
    </Form>
  );
}
